/**
 * Utility: classnames merger (clsx-like, no dependency needed)
 * Merges class strings, filters falsy values.
 */
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}
